import { Box } from '@mui/material'
import Hydraulic from '@/features/config/pages/Hydraulic'
import { GuidedStepComponentProps } from '../guidedSteps'

/**
 * SCRUM-1032 / SCRUM-1036 — Hydraulic dataset step of the guided Common Data setup.
 *
 * Embeds the /config Hydraulic grid (pipe tree + inline flow rule / valve / sensor editors)
 * scoped to the setup controller. The id comes from the guided-setup URL (`interfaceId` prop),
 * never AuthContext (SCRUM-976), so entry always targets the controller being set up.
 *
 * The Hydraulic page renders no page-level chrome (no ConfigLayout / title), so it drops straight
 * into a plain full-height container here.
 */
const HydraulicStep = ({ interfaceId }: GuidedStepComponentProps) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: '24px' }}>
      <Hydraulic interfaceId={interfaceId} embedded />
    </Box>
  )
}

export default HydraulicStep
